<div>
  <h5
    style="font-weight: 400; margin-top: 1rem; padding: 2rem 2rem 0 2rem; font-size: 1rem"
  >
    {{ 'utilities.filesControl.resume.description' | translate }}
  </h5>
  <div class="filters">
    <div class="col-md-3">
      <div class="form-group column">
        <h6 class="card-title">
          {{ 'record.filter.startDate' | translate }}
        </h6>
        <div>
          <input
            bsDatepicker
            [(ngModel)]="minDate"
            readonly
            class="form-control flatpickr flatpickr-input active"
            type="text"
            placeholder="Selecione una fecha"
            [bsConfig]="{
              isAnimated: true,
              containerClass: 'theme-dark-blue',
              dateInputFormat: 'DD-MM-YYYY'
            }"
            [maxDate]="maxDate"
          />
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group column">
        <h6 class="card-title">
          {{ 'record.filter.endDate' | translate }}
        </h6>
        <div>
          <input
            bsDatepicker
            [(ngModel)]="maxDate"
            readonly
            class="form-control flatpickr flatpickr-input active"
            type="text"
            placeholder="Selecione una fecha"
            [bsConfig]="{
              isAnimated: true,
              containerClass: 'theme-dark-blue',
              dateInputFormat: 'DD-MM-YYYY'
            }"
            [minDate]="minDate"
          />
        </div>
      </div>
    </div>
    <button
      style="padding: 5px 30px; width: 110px; height: 2rem; margin-left: 5rem"
      type="button"
      class="btn btn-primary"
      (click)="setFilters()"
      [disabled]="isLoading"
    >
      {{ 'record.filter.filter' | translate }}
    </button>
    <button
      style="padding: 5px 0px; width: 110px; height: 2rem; margin-left: 1rem"
      type="button"
      class="btn btn-outline-primary"
      (click)="cleanFilters()"
      [disabled]="isLoading"
    >
      {{ 'record.filter.cleanFilters' | translate }}
    </button>
  </div>
  <div class="charts">
    <div class="col-4">
      <div class="widget-heading">
        <h5>
          {{ 'utilities.filesControl.resume.ActivitiesOverTime' | translate }}
        </h5>
      </div>
      <div class="widget-content">
        <div class="d-flex justify-content-center loader" *ngIf="isLoading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div
          *ngIf="!isLoading && !hasActivitiesOverTime"
          class="d-flex justify-content-center"
        >
          <span>{{ 'noDataAvailable' | translate }}</span>
        </div>
        <div id="activitiesOverTime"></div>
      </div>
    </div>
    <div class="col-4">
      <div class="widget-heading">
        <h5 class="">
          {{
            'utilities.filesControl.resume.DocumentAccessByDepartment'
              | translate
          }}
        </h5>
      </div>
      <div class="widget-content">
        <div class="d-flex justify-content-center loader" *ngIf="isLoading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div
          *ngIf="!isLoading && !hasAccessOverTime"
          class="d-flex justify-content-center"
        >
          <span>{{ 'noDataAvailable' | translate }}</span>
        </div>
        <div id="documentAccessByDepartment"></div>
      </div>
    </div>
    <div class="col-4">
      <div class="widget-heading">
        <h5 class="">
          {{
            'utilities.filesControl.resume.DomainsWhereDocumentWasSent'
              | translate
          }}
        </h5>
      </div>
      <div class="widget-content">
        <div class="d-flex justify-content-center loader" *ngIf="isLoading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div
          *ngIf="!isLoading && !hasDomainsFileSent"
          class="d-flex justify-content-center"
        >
          <span>{{ 'noDataAvailable' | translate }}</span>
        </div>
        <div id="domainsWhereDocumentWasSent"></div>
      </div>
    </div>
  </div>
</div>
